import {useEffect, useRef} from "react";
import {Session} from "../model/Session";

export type EventWebSocket = {
    type: string,
    message : string
};
export const useWebSocketClient = (session : Session | undefined | null) => {
    const wsRef = useRef<WebSocket | null>(null);
    const listenersRef = useRef<Set<(payload: EventWebSocket) => void>>(new Set());

    const connect = () => {
        if (!session?.websocket) return;
        let websocket = session.websocket;
        if (websocket.name !== "awsapigatewayws") return;
        const ws = new WebSocket(`${websocket.endpoint}&user_id=${session.secret_id}`);
        wsRef.current = ws;

        ws.onopen = () => {
            console.log("WebSocket connected");
        };

        ws.onmessage = (event) => {
            const payload = JSON.parse(event.data);
            const data : EventWebSocket = {
                message: payload.message,
                type: payload.type
            }
            listenersRef.current.forEach((callback) => callback(data));
        };

        ws.onclose = (event) =>{
            if (event.code === 4999 && event.reason === 'unmounted') return;
            console.warn("WebSocket closed, attempting reconnection...");
            setTimeout(connect, 5000);
        };
        ws.onerror = (error) => {
            console.error("WebSocket error:", error);
            ws.close();
        };
    };

    useEffect(() => {
        connect();

        return () => {
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                wsRef.current.close(4999, "unmounted");
            }
        };
    }, [session]);

    const subscribe = (callback : (payload : EventWebSocket) => void) => {
        listenersRef.current.add(callback);
        return () => {
            listenersRef.current.delete(callback);
        };
    };

    return { subscribe };
};